import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { AwsMarketplaceErrorComponent } from './components/aws-marketplace-error/aws-marketplace-error.component'
import { AwsMarketplaceComponent } from './components/aws-marketplace/aws-marketplace.component'
import { SelectLinkedAccountComponent } from './components/select-linked-account/select-linked-account.component'

const routes: Routes = [
  {
    path: 'aws_marketplace',
    component: AwsMarketplaceComponent,
  },
  {
    path: 'aws_marketplace/link_account',
    component: SelectLinkedAccountComponent,
  },
  {
    path: 'aws_marketplace/error',
    component: AwsMarketplaceErrorComponent,
  },
]

@NgModule({
  declarations: [],
  imports: [RouterModule.forChild(routes)],
})
export class AwsMarketplaceRoutingModule {}
